import { useCssModule as e, computed as n } from "vue";
function c(s) {
  const t = e(), o = "cdr-rating", r = n(() => s ? `${o}__star--${s}` : "");
  return {
    style: t,
    sizeClass: r
  };
}
export {
  c as useStar
};
